module.exports = __webpack_public_path__ + "img/13.e964de0a.jpg";